// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

import { tns } from "tiny-slider/src/tiny-slider";

export default class SubScrollTinySlider extends WebComponent {
	didMount() {


		var slider = tns({
			container: '.sub-slider__list',
			controlsContainer: '.sub-slider__controls',
			mode: 'gallery',
			items: 1,
			nav: false,
			slideBy: 'page',
			autoplay: false,
			rewind: true,
			mouseDrag: true
		});
	}
}



// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/TinySliders/SubScrollTinySlider.js